class AgeGate extends HTMLElement {
  constructor() {
    super();
    this.listeners();
  }

  listeners() {
    if (Shopify.designMode || document.cookie.split(";").some((cookie) => cookie.trim().startsWith('age_gate='))) return;

    document.documentElement.classList.add('age-gate-active');

    const ageGateConfirm = this.querySelector('.js-age-gate-confirm');

    if (!ageGateConfirm) return;

    ageGateConfirm.addEventListener('click', () => {
      // Max age 30 days
      document.cookie = 'age_gate=confirm;max-age=2592000';
      document.documentElement.classList.remove('age-gate-active');
    });
  }
}

customElements.define('age-gate', AgeGate);
